/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".with-loading[_ngcontent-%COMP%]{height:40px}.with-loading[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{margin:auto}"];
export { styles as styles };
